import { Box, Button, Grid, Typography,Skeleton  } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
// import hero1 from "../../assets/hero1.png";
import CustomText, { textStyles } from "../../components/CustomText";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import more from "../../assets/more.svg";
import GetAppButton from "../../components/GetAppButton";
import FeaturesHeroCard from "../../components/cards/FeaturesHeroCard";

import hero1 from "../../assets/TimeTracking/hero1.webp";
import herocard1 from "../../assets/TimeTracking/herocard1.webp";
import herocard3 from "../../assets/TimeTracking/herocard3.webp"
// import herocard4 from "../../assets/TimeTracking/herocard4.webp";
import herocard6 from "../../assets/TimeTracking/herocard6.webp";
import herocard8 from "../../assets/TimeTracking/herocard8.webp";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
// import hero1es from "../../assets/spanish/TimeTracking/hero1es.webp";
import hero1es from "../../assets/spanish/Task Management/hero1es.webp";
import heroimage from "../../assets/Task Management/heroimage.webp";
import hero2es from "../../assets/spanish/TimeTracking/hero2es.webp";
import hero3es from "../../assets/spanish/TimeTracking/hero3es.webp";
// import hero4es from "../../assets/spanish/TimeTracking/hero4es.webp";
import hero6es from "../../assets/spanish/TimeTracking/hero6es.webp";
import hero5es from "../../assets/spanish/TimeTracking/hero5es.webp";
import hero3en from "../../assets/spanish/TimeTracking/hero3en.png";
import herocard7 from "../../assets/TimeTracking/herocard7.webp";
import herocard8es from "../../assets/spanish/TimeTracking/herocard8es.webp";
import { useState } from "react";
import { BASE_URL } from "../../components/BASE_URL";
import { useSocialLinks } from "../../components/fetchGetAppUrl";
const HeroSection = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const navigate = useNavigate();
  const [heroData, setHeroData] = useState(null);
  const [loading, setLoading] = useState(true);
  const hero_section_button_text = {
    main: "var(--Tertiary, #003149)",
    hover: "#00263a",
    contrastText: "#FFFFFF",
    fontSize: "18px",
  };
  const location = useLocation();


  const { links, } = useSocialLinks();

  const parseFeatureNames = (list) => {
    try {
      const items = Array.isArray(list)
        ? list
        : list
          ? JSON.parse(list)
          : [];
      return items.map((f) => f.name);
    } catch {
      return [];
    }
  };

  useEffect(() => {
  const fetchHeroData = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Features_Time_Tracking`
      );
      const json = await res.json();

      if (!json.error && json.data?.length > 0) {
        const section = json.data[0];

        // 🔹 Pick EN (idx 0) or ES (idx 1)
        const selectedItem =
          i18n.language === "es"
            ? section.items.find((item) => item.idx === 1)
            : section.items.find((item) => item.idx === 0);

        if (selectedItem) {
          setHeroData({
            title: selectedItem.title,
            description: selectedItem.description,
          });
        }
      }
    } catch (err) {
      console.error("Error fetching Hero Section:", err);
    } finally {
      setLoading(false);
    }
  };

  fetchHeroData();
}, [i18n.language]); // 🔑 re-fetch when language changes




useEffect(() => {
  const hash = window.location.hash;

  if (hash) {
    // Give time for DOM/rendering/layout/styles to finish
    setTimeout(() => {
      const id = hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 300); // Adjust timeout if needed
  }
}, []);




  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  const handleMore = () => {
    navigate("/product-tour");
  };
  // const heroImageSrc = i18n.language === "es" ? hero1es : hero1;
    const heroImageSrc = i18n.language === "es" ? hero1es : heroimage;
  const Card1 = i18n.language === "es" ? hero2es : herocard1;
  const Card2 = i18n.language === "es" ? hero5es : herocard3;
  // const Card3 = i18n.language === "es" ? hero4es : herocard4;
  const Card4 = i18n.language === "es" ? hero3es : herocard6;
  const Card5 = i18n.language === "es" ? hero6es : herocard7;
    const Card6 = i18n.language === "es" ? herocard8es : herocard8;



    const [facialData, setFacialData] = useState(null);
const [facialLoading, setFacialLoading] = useState(true);

useEffect(() => {
  const fetchFacialData = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Facial_Recognition`
      );
      const json = await res.json();

      if (!json.error && json.data?.length > 0) {
        const section = json.data[0];
        const item =
          i18n.language === "es"
            ? section.items.find((it) => it.idx === 1)
            : section.items.find((it) => it.idx === 0);

        const parsedList = parseFeatureNames(item?.list);

        setFacialData({
          title: item?.title || "",
          description: item?.description || "",
          features: parsedList,
          url: item?.url || null,
          icon: item?.icon_image_url || null,
        });
      }
    } catch (err) {
      console.error("Error fetching Facial Recognition data:", err);
    } finally {
      setFacialLoading(false);
    }
  };

  fetchFacialData();
}, [i18n.language]); // 🔑 re-run on language change




const [clockData, setClockData] = useState(null);
const [clockLoading, setClockLoading] = useState(true);

useEffect(() => {
  const fetchClockData = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=ClockIn_Out`
      );
      const json = await res.json();

      if (!json.error && json.data?.length > 0) {
        const section = json.data[0];
        const item =
          i18n.language === "es"
            ? section.items.find((it) => it.idx === 2)
            : section.items.find((it) => it.idx === 1);

        const parsedList = parseFeatureNames(item?.list);

        setClockData({
          title: item?.title || "",
          description: item?.description || "",
          features: parsedList,
          url: item?.url || null,
          icon: item?.icon_image_url || null,
        });
      }
    } catch (err) {
      console.error("Error fetching ClockIn_Out data:", err);
    } finally {
      setClockLoading(false);
    }
  };

  fetchClockData();
}, [i18n.language]);// 🔑 re-run when lang changes




const [breakData, setBreakData] = useState(null);
const [breakLoading, setBreakLoading] = useState(true);
// BREAK
useEffect(() => {
  const fetchBreakData = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Break_Time`
      );
      const json = await res.json();

      if (!json.error && json.data?.length > 0) {
        const section = json.data[0];
        const item =
          i18n.language === "es"
            ? section.items.find((it) => it.idx === 1) || section.items.find((it) => it.idx === 2)
            : section.items.find((it) => it.idx === 0);

        const parsedList = parseFeatureNames(item?.list);

        setBreakData({
          title: item?.title || "",
          description: item?.description || "",
          features: parsedList,
          url: item?.url || null,
          icon: item?.icon_image_url || null,
        });
      }
    } catch (err) {
      console.error("Error fetching Break_Time data:", err);
    } finally {
      setBreakLoading(false);
    }
  };

  fetchBreakData();
}, [i18n.language]); // 🔑 runs again when language changes




const [offlineData, setOfflineData] = useState(null);
const [offlineLoading, setOfflineLoading] = useState(true);


// OFFLINE
useEffect(() => {
  const fetchOfflineData = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Offline_Clocking`
      );
      const json = await res.json();

      if (!json.error && json.data?.length > 0) {
        const section = json.data[0];
        const item =
          i18n.language === "es"
            ? section.items.find((it) => it.idx === 1) || section.items[0]
            : section.items.find((it) => it.idx === 0) || section.items[0];

        const parsedList = parseFeatureNames(item?.list);

        setOfflineData({
          title: item?.title || "",
          description: item?.description || "",
          features: parsedList,
        });
      }
    } catch (err) {
      console.error("Error fetching Offline_Clocking data:", err);
    } finally {
      setOfflineLoading(false);
    }
  };

  fetchOfflineData();
}, [i18n.language]);




const [customRulesData, setCustomRulesData] = useState(null);
const [customRulesLoading, setCustomRulesLoading] = useState(true);
useEffect(() => {
  const fetchCustomRulesData = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Custom_Rules`
      );
      const json = await res.json();

      if (!json.error && json.data?.length > 0) {
        const section = json.data[0];
        const item =
          i18n.language === "es"
            ? section.items.find((it) => it.idx === 1) || section.items[0]
            : section.items.find((it) => it.idx === 0) || section.items[0];

        const parsedList = parseFeatureNames(item?.list);

        setCustomRulesData({
          title: item?.title || "",
          description: item?.description || "",
          features: parsedList,
        });
      }
    } catch (err) {
      console.error("Error fetching Custom_Rules data:", err);
    } finally {
      setCustomRulesLoading(false);
    }
  };

  fetchCustomRulesData();
}, [i18n.language]);



  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          alignItems: "center",
          px: isMobile ? 2 : 8,
          py: 3,
          backgroundColor: "#fff",
          gap: 6,
          marginTop: "70px",
        }}
      >
        <Box
          sx={{
            flex: 1,
            textAlign: { xs: "center", md: "left",py:3 },
          }}
        >
        
             {loading ? (
            <Skeleton variant="text" width={300} height={60} />
          ) : (
            <CustomText
              style={{
                ...textStyles.h1,
                marginBottom: isMobile ? "0rem" : "1rem",
                marginTop: isMobile ? "0rem" : "1rem",
                fontSize: isMobile ? "36px" : "52px",
                textAlign: isMobile ? "center" : "left",
              }}
            >
              {heroData?.title}
            </CustomText>
          )}

       

               {loading ? (
            <Skeleton variant="text" width={500} height={40} />
          ) : (
            <CustomText
              style={{
                ...textStyles.body1,
                color: "#868282",
                margin: "0 auto",
                marginTop: "10px",
                textAlign: isMobile ? "center" : "left",
              }}
            >
              {heroData?.description}
            </CustomText>
          )}
          <Box
            sx={{
              display: "flex",
              flexWrap: isMobile ? "wrap" : "nowrap",
              justifyContent: isMobile ? "center" : "flex-start",
              alignItems: "center",
              mt: isMobile ? "10px" : 4,
              gap: 1,
            }}
          >
            <GetAppButton
              label={t("get_app_now")}
              variant="primary"
              size="large"
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 0,
                   cursor: "pointer",
              }}
              onClick={handleMore}
            >

              <img
                src={more || "/placeholder.svg"}
                style={{ width: "65px", height: "65px" }}
              />
              <p
                style={{
                  color: hero_section_button_text.main,
                  fontSize: "18px",
                  fontWeight: 600,
                  fontFamily: "Poppins, sans-serif",
               
                }}
              >
                {t("Learn More")}
              </p>
            </Box>
          </Box>
        </Box>

        {/* Right Section - Image */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            // alignItems: "center",
            mt: { xs: 4, md: 0 },
            py:1,
          }}
        >
          <Box
            component="img"
            // src={hero1}
            src={heroImageSrc}
            alt="Dashboard Preview"
            sx={{
              width: "100%",
              maxWidth: "800px",
              height: "auto",
              objectFit:"contain"
            }}
          />
        </Box>
      </Box>
      <Box>
       
        <Box id="face-recognition-validation">
  {facialLoading ? (
    <Box sx={{ p: 3 }}>
      <Skeleton variant="text" width={250} height={40} />
      <Skeleton variant="text" width={500} height={30} />
      <Skeleton variant="rectangular" width="100%" height={150} sx={{ mt: 2 }} />
    </Box>
  ) : (
    <FeaturesHeroCard
      bgColor="#EFF4F8"
      image={Card1}
      imagePosition="left"
      title={facialData?.title}
      description={facialData?.description}
      features={facialData?.features}
    />
  )}
</Box>

              

        <Box
  id="card1-attendence"
  sx={{
    scrollMarginTop: "-20px",
  }}
>
  {clockLoading ? (
    <Box sx={{ p: 3 }}>
      <Skeleton variant="text" width={250} height={40} />
      <Skeleton variant="text" width={500} height={30} />
      <Skeleton variant="rectangular" width="100%" height={150} sx={{ mt: 2 }} />
    </Box>
  ) : (
    <FeaturesHeroCard
      bgColor="#FFFFFF"
      image={Card6}
      imagePosition="right"
      title={clockData?.title}
      description={clockData?.description}
      features={clockData?.features}
    />
  )}
</Box>


        <Box id="break-time-tracking">
  {breakLoading ? (
    <Box sx={{ p: 3 }}>
      <Skeleton variant="text" width={250} height={40} />
      <Skeleton variant="text" width={500} height={30} />
      <Skeleton variant="rectangular" width="100%" height={150} sx={{ mt: 2 }} />
    </Box>
  ) : (
    <FeaturesHeroCard
  bgColor="#EFF4F8"
  image={Card2}
  imagePosition="left"
  title={breakData?.title}
  description={breakData?.description}   // keep text only
  features={breakData?.features}         // pass array properly
/>
  )}
</Box>

       
        



        <Box id="offline-clocking-support">
  {offlineLoading ? (
    <Box sx={{ p: 3 }}>
      <Skeleton variant="text" width={250} height={40} />
      <Skeleton variant="text" width={500} height={30} />
      <Skeleton variant="rectangular" width="100%" height={150} sx={{ mt: 2 }} />
    </Box>
  ) : (
    <FeaturesHeroCard
      bgColor="#FFFFFF"
      image={Card4}
      imagePosition="left"
      title={offlineData?.title}
      description={offlineData?.description}
      features={offlineData?.features}
    />
  )}
</Box>


      
        <Box id="custom-rules-restrictions">
  {customRulesLoading ? (
    <Box sx={{ p: 3 }}>
      <Skeleton variant="text" width={250} height={40} />
      <Skeleton variant="text" width={500} height={30} />
      <Skeleton variant="rectangular" width="100%" height={150} sx={{ mt: 2 }} />
    </Box>
  ) : (
    <FeaturesHeroCard
      bgColor="#EFF4F8"
      image={Card5}
      imagePosition="right"
      title={customRulesData?.title}
      description={customRulesData?.description}
      features={customRulesData?.features}
    />
  )}
</Box>

      </Box>
    </>
  );
};
export default HeroSection;
